<script setup lang="ts">
import LoadingSpinner from '../../base/LoadingSpinner.vue'
import { amountFormatter } from '../../../utilities/helpers'
import { getAccountLink } from '../../../utilities/useLinks'
import { onMounted } from 'vue'
import { replaceCurrencyWithCurrencySymbol } from '../../../utilities/helpers'
import { usePersonalAccountDataState } from '../../../utilities/account/useAccountDataPersonal'

//@ts-ignore
const accountState = usePersonalAccountDataState()

onMounted(async () => {
    await accountState.fetchAccountData()
})
</script>

<template>
    <!-- Aside content -->
    <aside v-if="accountState.loaded" class="orders-content">
        <div class="box-shadow mb-4 bg-white p-3">
            <div class="d-flex align-items-center flex-wrap justify-between text-secondary">
                <div class="">
                    <p class="align-items-center d-flex bold mb-0 text-secondary">
                        <span class="ion-ios-person large mr-2"></span>
                        {{ $t('account_settings.overview') }}
                    </p>
                </div>
                <div class="text-right">
                    <a :href="getAccountLink()" class="bold text-secondary">
                        <span class="ion-edit mr-2"></span>{{ $t('account_settings.edit') }}
                    </a>
                </div>
            </div>
            <hr />
            <div class="d-flex align-items-center flex-wrap">
                <div class="spot d-flex align-items-center xlarge mr-3 justify-center rounded bg-primary text-white">
                    {{ accountState.naturalProfile.first_name.toString().substring(0, 1)
                    }}{{ accountState.naturalProfile.last_name.toString().substring(0, 1) }}
                </div>
                <div class="flex-1">
                    <h4 class="text-gray-blue d-i-block mb-0 mr-3">
                        <strong>
                            {{ accountState.naturalProfile.first_name }}
                            {{ accountState.naturalProfile.last_name }}
                        </strong>
                    </h4>
                </div>
            </div>
            <div class="investor-details my-3">
                <div class="row d-flex align-items-center investor-birth text-gray-blue mb-2 flex-wrap">
                    <div
                        v-if="accountState.naturalProfile.date_of_birth"
                        class="c6 d-flex align-items-center flex-wrap">
                        <i class="fa fa-calendar-o mr-2" aria-hidden="true"></i>
                        {{
                            new Date(accountState.naturalProfile.date_of_birth).toLocaleDateString('at', {
                                // @Todo: show time format maybe via "user preferred" language?
                                day: '2-digit',
                                month: '2-digit',
                                year: 'numeric',
                                timeZone: 'Europe/Vienna',
                            })
                        }}
                    </div>
                    <div v-if="accountState.naturalProfile.country_name" class="c6 d-flex align-items-center flex-wrap">
                        <i class="fa fa-flag mr-2" aria-hidden="true"></i>
                        {{ accountState.naturalProfile.country_name }}
                    </div>
                </div>
            </div>
            <hr />
            <div
                v-if="
                    accountState.naturalProfile.address ||
                    accountState.naturalProfile.postal_code ||
                    accountState.naturalProfile.city ||
                    accountState.naturalProfile.state ||
                    accountState.naturalProfile.country_name
                "
                class="investor-address">
                <p class="text-gray-blue d-flex align-items-center">
                    <span class="icon ion-ios-location large mr-2"></span>
                    {{
                        `
                        ${accountState.naturalProfile.address ? `${accountState.naturalProfile.address}, ` : ``}
                        ${accountState.naturalProfile.postal_code ? `${accountState.naturalProfile.postal_code}, ` : ``}
                        ${accountState.naturalProfile.city ? `${accountState.naturalProfile.city}` : ``}
                    `
                    }}
                </p>
                <p
                    v-if="accountState.naturalProfile.state || accountState.naturalProfile.country_name"
                    class="text-gray-blue d-flex align-items-center mb-0">
                    <span class="icon ion-map large mr-2"></span>
                    {{
                        `
                          ${accountState.naturalProfile.state ? `${accountState.naturalProfile.state}, ` : ``}
                          ${
                              accountState.naturalProfile.country_name
                                  ? `${accountState.naturalProfile.country_name}`
                                  : ``
                          }
                      `
                    }}
                </p>
            </div>
        </div>
        <div v-if="accountState.naturalProfile.portfolio_sum.length" class="box-shadow mb-4 bg-white p-3">
            <strong> {{ $t('portfolio_size') }}: </strong>
            <span v-for="(ps, index) in accountState.naturalProfile.portfolio_sum" :key="index">
                {{ amountFormatter(ps.portfolio_sum) }} {{ replaceCurrencyWithCurrencySymbol(ps.currency) }}
                <br />
            </span>
        </div>
    </aside>
    <div v-else class="flex h-[65vh] items-center justify-center">
        <LoadingSpinner class="h-10 w-10 fill-primary" />
    </div>
    <!-- End Aside content -->
</template>

<style scoped></style>
